// models
import type { BaseSearchRequest } from 'modules';

/**
 * Protection 관련 Query Keys
 *
 * @description
 * 개인보호구 지급 관련 query-key들을 관리합니다.
 */
export const protectionKeys = {
  /** ALL */
  PROTECTION_ALL: ['protection'],

  /** 작업자 보호구 지급 이력 전체 조회 */
  GET_PROTECTIONS: (userId: string, query: BaseSearchRequest) => [
    'protection',
    'getProtections',
    userId,
    JSON.stringify(query)
  ],

  /** 작업자 보호구 별 마지막 지급 이력 조회 */
  GET_LAST_PROTECTIONS: (userId: string) => ['protection', 'getLastProtections', userId]
};
